export default __webpack_public_path__ + "static/media/home-activities-networking-mobile.51f2edb5.png";